// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.redeem-request-containers {
    max-width: 1800px;
    margin: 60px;
    padding: 20px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
  
  .page-titles {
    color: #2c3e50;
    text-align: center;
    margin-bottom: 30px;
    font-size: clamp(1.5rem, 2.5vw, 2rem);
  }
  
  /* Filter Controls */
  .filter-controlss {
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
  }
  
  .status-filterss {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  
  .status-filterss button {
    padding: 8px 16px;
    border: 1px solid #ddd;
    border-radius: 20px;
    background: #67a7d1;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 0.9rem;
  }
  
  .status-filterss button.active {
    background-color: #4ad862;
    color: white;
    border-color: #4ad862;
  }
  
  /* Table Styles */
  .request-table-container {
    overflow-x: auto;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
  }
  
  .request-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 600px;
  }
  
  .request-table th {
    background-color: #3498db;
    color: white;
    font-weight: 600;
    padding: 15px;
    text-align: left;
  }
  
  .request-table td {
    padding: 12px 15px;
    border-bottom: 1px solid #eee;
  }
  
  .request-table tr:hover {
    background-color: #f9f9f9;
  }
  
  /* Status Select Dropdown */
  .status-select {
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid #ddd;
  }
  
  .status-select.open {
    background-color: #fff3cd;
    color: #856404;
    border-color: #ffeeba;
  }
  
  .status-select.in-process {
    background-color: #cce5ff;
    color: #004085;
    border-color: #b8daff;
  }
  
  .status-select.delivered {
    background-color: #d4edda;
    color: #155724;
    border-color: #c3e6cb;
  }
  
  /* Loading and No Data States */
  .loading-spinner {
    padding: 40px;
    text-align: center;
    color: #666;
  }
  
  .no-data {
    text-align: center;
    padding: 30px;
    color: #666;
  }
  
  /* Responsive Design */
  @media (max-width: 992px) {
    .filter-controls {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  
  @media (max-width: 768px) {
    .redeem-request-container {
      padding: 15px;
    }
    
    .request-table th,
    .request-table td {
      padding: 10px 12px;
      font-size: 0.9rem;
    }
  }
  
  @media (max-width: 576px) {
    .redeem-request-container {
      padding: 10px;
    }
    
    .status-filters {
      width: 100%;
    }
    
    .status-filters button {
      flex: 1 1;
      text-align: center;
    }
    
    .request-table th,
    .request-table td {
      padding: 8px 10px;
      font-size: 0.85rem;
    }
    
    .status-select {
      padding: 4px 8px;
      font-size: 0.8rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/MyComponents/MyRewards/RedeemRequest.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,4DAA4D;EAC9D;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;EACvC;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;EACvB;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,2BAA2B;EAC3B;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;EACb;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;;MAEE,kBAAkB;MAClB,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,SAAO;MACP,kBAAkB;IACpB;;IAEA;;MAEE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;EACF","sourcesContent":["/* Main Container */\n.redeem-request-containers {\n    max-width: 1800px;\n    margin: 60px;\n    padding: 20px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  }\n  \n  .page-titles {\n    color: #2c3e50;\n    text-align: center;\n    margin-bottom: 30px;\n    font-size: clamp(1.5rem, 2.5vw, 2rem);\n  }\n  \n  /* Filter Controls */\n  .filter-controlss {\n    margin-bottom: 25px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n  \n  .status-filterss {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n  }\n  \n  .status-filterss button {\n    padding: 8px 16px;\n    border: 1px solid #ddd;\n    border-radius: 20px;\n    background: #67a7d1;\n    cursor: pointer;\n    transition: all 0.3s;\n    font-size: 0.9rem;\n  }\n  \n  .status-filterss button.active {\n    background-color: #4ad862;\n    color: white;\n    border-color: #4ad862;\n  }\n  \n  /* Table Styles */\n  .request-table-container {\n    overflow-x: auto;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    background: #fff;\n  }\n  \n  .request-table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 600px;\n  }\n  \n  .request-table th {\n    background-color: #3498db;\n    color: white;\n    font-weight: 600;\n    padding: 15px;\n    text-align: left;\n  }\n  \n  .request-table td {\n    padding: 12px 15px;\n    border-bottom: 1px solid #eee;\n  }\n  \n  .request-table tr:hover {\n    background-color: #f9f9f9;\n  }\n  \n  /* Status Select Dropdown */\n  .status-select {\n    padding: 6px 12px;\n    border-radius: 4px;\n    font-size: 0.85rem;\n    font-weight: 500;\n    cursor: pointer;\n    border: 1px solid #ddd;\n  }\n  \n  .status-select.open {\n    background-color: #fff3cd;\n    color: #856404;\n    border-color: #ffeeba;\n  }\n  \n  .status-select.in-process {\n    background-color: #cce5ff;\n    color: #004085;\n    border-color: #b8daff;\n  }\n  \n  .status-select.delivered {\n    background-color: #d4edda;\n    color: #155724;\n    border-color: #c3e6cb;\n  }\n  \n  /* Loading and No Data States */\n  .loading-spinner {\n    padding: 40px;\n    text-align: center;\n    color: #666;\n  }\n  \n  .no-data {\n    text-align: center;\n    padding: 30px;\n    color: #666;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 992px) {\n    .filter-controls {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .redeem-request-container {\n      padding: 15px;\n    }\n    \n    .request-table th,\n    .request-table td {\n      padding: 10px 12px;\n      font-size: 0.9rem;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .redeem-request-container {\n      padding: 10px;\n    }\n    \n    .status-filters {\n      width: 100%;\n    }\n    \n    .status-filters button {\n      flex: 1;\n      text-align: center;\n    }\n    \n    .request-table th,\n    .request-table td {\n      padding: 8px 10px;\n      font-size: 0.85rem;\n    }\n    \n    .status-select {\n      padding: 4px 8px;\n      font-size: 0.8rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
